'use client'

import React from 'react'
import type { Header as HeaderType } from '@/payload-types'
import Link from 'next/link'
import { Logo } from '@/components/Logo/Logo'
import { CartIcon } from '@/components/CartIcon'
import { CartSidebar } from '@/components/CartSidebar'
import { CMSLink } from '@/components/Link'
import { NavDrawer } from '@/components/NavDrawer'
import { useFeatureFlags } from '@xtr-dev/payload-feature-flags/client'

export const HeaderNav: React.FC<{ header: HeaderType }> = ({ header }) => {
  const allNavItems = header?.navItems || []

  const { flags: [basketFlag, productsFlag] } = useFeatureFlags([
    {
      name: 'nav-basket',
      enabled: false,
    },
    {
      name: 'nav-products',
      enabled: false,
    },
  ])

  // Build feature flags map for filtering
  const flagMap: Record<string, boolean> = {
    'nav-basket': basketFlag.enabled ?? false,
    'nav-products': productsFlag.enabled ?? false,
  }

  // Filter nav items by feature flag
  const navItems = allNavItems.filter((item) => {
    if (item.featureFlag) {
      return flagMap[item.featureFlag] ?? true
    }
    return true
  })

  // Convert feature flags to the format expected by NavDrawer
  const featureFlags = Object.entries(flagMap).map(([name, enabled]) => ({ name, enabled }))

  return (
    <div className="bg-white">
      <div className="container relative h-16 flex items-center justify-between">
        <Link href="/">
          <Logo loading="eager" priority="high" />
        </Link>
        <div className="flex items-center gap-4">
          <nav className="hidden md:flex gap-4 items-center">
            {navItems.map(({ link }, i) => {
              return <CMSLink key={i} {...link} />
            })}
          </nav>
          <nav className="flex items-center gap-2">
            {/* Cart Icon */}
            {basketFlag.enabled && <CartIcon />}

            {/* Unified Navigation Drawer */}
            <NavDrawer featureFlags={featureFlags} header={header} context="frontend" />
          </nav>
        </div>
      </div>

      {/* Cart Sidebar */}
      <CartSidebar />
    </div>
  )
}
